import { useEffect, useState } from "react";
import axios from "axios";

let cache = null;
let inflight = null;

// Shared /home/feed fetch (stats, app links, contacts) for the home page and Azbit-style page chrome.
export const useHomeFeed = () => {
  const [feed, setFeed] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/home/feed`).then((r) => r.data).catch(() => ({}));
    inflight.then((d) => { cache = d; setFeed(d); });
  }, []);
  return feed;
};
